export { setJudicialStatusColor } from "./setJudicialStatusColor/setJudicialStatusColor"
export { getCommunicationStep } from "./getCommunicationStep/getCommunicationStep"
export { setDelayedDaysColor } from "./setDelayedDaysColor/setDelayedDaysColor"
